export const HomePage = (props: any) => {

    return (
        <>
            <div className="hero-banner">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-md-6">
                            <div className="hero-banner__inner">
                                <h1 className="hero-banner__title">GP Diary</h1>
                                <h2 className="hometext">Built for doctors, by doctors</h2>
                                <div className="hero-banner-meta">
                                    <p className="loggedin">
                                        Record your daily work activities, then create reports to review your
                                        work patterns.
                                    </p>
                                    <p className="loggedin">
                                        GP Diary can be used by any GP role type to track worked time. Where relevant, it also compares worked time to contracted hours.
                                    </p>
                                </div>
                            </div>
                            <br />
                            <div className="float start">
                                <button className="btn btn-primary" onClick={() => props.login()}>
                                    Start Now
                                </button>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6">
                            <figure className="hero-banner__rotachecker">
                                <img src={require('../../../assets/images/home-page-Image.png')} alt="home-page-Image" />
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}